/**
 * The Review header's secondary count, or `undefined` when it would only
 * repeat the number beside it.
 *
 * The header prints `Review · N daily logs to review` as its crumb. A second
 * count saying `N yours` next to it is the same fact twice; it earns its
 * place only when your share is a DIFFERENT number, which is the case the
 * "whose queue is this?" wording exists for in the first place.
 */
export function reviewCountNote(pending: number, yours: number): string | undefined {
  if (pending === 0 || yours === 0 || yours === pending) return undefined;
  return `${yours} yours`;
}
